import { render, staticRenderFns } from "./PopUpTable.vue?vue&type=template&id=82b0e77e&scoped=true"
import script from "./PopUpTable.vue?vue&type=script&lang=js"
export * from "./PopUpTable.vue?vue&type=script&lang=js"
import style0 from "./PopUpTable.vue?vue&type=style&index=0&id=82b0e77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b0e77e",
  null
  
)

export default component.exports